import { type SortDirection } from '@factorialco/deprecated-design-system'
import { isEmpty } from 'lodash'
import compact from 'lodash/compact'
import orderBy from 'lodash/orderBy'

import { matchText } from 'modules/core/lib/stringUtils'

import type Employee from 'modules/employees/store/models/Employee'
import goals from 'modules/goals/store/collections/goals'
import type Goal from 'modules/goals/store/models/Goal'

export type MetadataAttr =
  | 'user_name'
  | 'goal_value_in_cents'
  | 'current_value_in_cents'
  | 'goal_progress'

export const sortGoals = (
  filteredBySearch: Goal[],
  attribute: string, // NOTE: This can't be MetadataAttr because we read also from goal.attributes
  direction: SortDirection
) => {
  switch (attribute) {
    case 'goal_value_in_cents':
    case 'current_value_in_cents':
      return orderBy(filteredBySearch, (g) => g.metadata[attribute], [direction])

    case 'user_name':
      return orderBy(filteredBySearch, (g) => g.user?.fullName(), [direction])

    case 'goal_progress':
      return orderBy(filteredBySearch, (g) => g.metadata[attribute], [direction])

    default:
      return orderBy(filteredBySearch, (g) => g.attributes[attribute], [direction])
  }
}

export const filterBySearch = (search: string): Goal[] =>
  goals.models.filter((goal: Goal) => {
    if (isEmpty(search)) return goals.models

    const text = goal.user ? goal.user.fullName() : ''

    return matchText(search, text)
  })

export const filterByStatus = (filteredBySearch: Goal[], progressStatus: string): Goal[] =>
  filteredBySearch.filter((goal: Goal) => {
    if (!progressStatus.length) return filteredBySearch

    return goal.attributes.progress_status === progressStatus
  })

export const filterByEmployee = (
  filteredByStatus: Goal[],
  filteredEmployees: Employee[],
  filterBy: string
): Goal[] =>
  filteredByStatus.filter((goal: Goal) => {
    if (!filterBy.length) return filteredByStatus

    const ids = compact(filteredEmployees.map((employee) => employee.attributes.access_id))

    return ids.includes(goal.attributes.owner_id)
  })
